import React, { useEffect, useState } from "react";
import { Modal, Select, Tooltip, Form } from "antd";
import { userRoleOptions } from "../../../utils/comman";
import OrganizationListing from "../DropdownsListing/OrganizationListing";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";

interface roleModelProps {
  handleConfirmRoleModel?: () => void;
  handleModelFunction?: () => void;
  userId?: string;
  setUserRoleId?: (id: any) => void;
  setOrgId?: (id: any) => void;
  accessRoleId?: any;
}

const ChangeUserRoleModel: React.FC<roleModelProps> = ({
  handleConfirmRoleModel,
  handleModelFunction,
  userId,
  setUserRoleId,
  setOrgId,
  accessRoleId,
}) => {
  const { Option } = Select;
  const [form] = Form.useForm();

  const [isChecked, setIsChecked] = useState(false);

  // Filter role options based on current user's roleId
  const filteredRoleOptions = userRoleOptions.filter((role) => {
    if (accessRoleId === 4) return role.id === 2 || role.id === 3;
    if (accessRoleId === 2 || accessRoleId === 3) return role.id === 4;
    return false; // fallback: no options shown for other roles
  });

  const isConfirmDisabled =
    !form.getFieldValue("isChecked") ||
    !form.getFieldValue("organizationId") ||
    !form.getFieldValue("roleId");

  return (
    <Modal
      centered
      open={true}
      onCancel={handleConfirmRoleModel}
      className="custom-modal-col"
    >
      <Form
        form={form}
        layout="vertical"
        onValuesChange={(changedValues, allValues) => {
          setUserRoleId(allValues?.roleId);
          setOrgId(allValues?.organizationId);
          setIsChecked(allValues?.isChecked);
        }}
      >
        <div className="text-center">
          <div className="text-center mb-3">
            <h1>Change Role</h1>
          </div>
          <Form.Item name="organizationId">
            <OrganizationListing
              dataToSet={[]}
              keyName={"organizationId"}
              idType="userOrg"
              apiEndpointId={userId}
            />
          </Form.Item>
          <div>
            <Tooltip title="Role">
              <Form.Item name="roleId">
                <Select
                  placeholder="Role"
                  className="input-main-col focus:bg-transparent rounded-[5px] mb-[0px] p-[10px] border-1 border-transparent focus:border-white w-full bg-[#013351] placeholder-[#195A90] color-[#fff] h-auto"
                >
                  {filteredRoleOptions?.map((role) => (
                    <Option key={role.id} value={role.id}>
                      {role.name}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </Tooltip>
          </div>

          <div className="mt-3 mb-3 flex items-center justify-center">
            <Form.Item name="isChecked" valuePropName="checked" noStyle>
              <label className="flex items-center">
                <input type="checkbox" />
                <span className="text-white ml-3">
                  Continue with this change?
                </span>
              </label>
            </Form.Item>
          </div>

          <button
            className="gradient-button py-[15px] px-[80px] rounded-md text-[12px] 2xl:text-sm w-full"
            onClick={() => handleModelFunction?.()}
            disabled={isConfirmDisabled}
          >
            Confirm
          </button>

          <button
            className="btn-secondary bg-transparent border-0 text-[#48BA89] text-sm mt-[30px]"
            onClick={handleConfirmRoleModel}
          >
            Cancel
          </button>
        </div>
      </Form>
    </Modal>
  );
};

export default ChangeUserRoleModel;
